<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Добавление позиции') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <position-info-fix
            v-if="dialogProp.lot.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :hide-delivery-condition="hideDeliveryCondition"
            :validated="createPosition" />
        <position-info-differential
            v-else
            ref="position"
            :lot-owner-organization-name="lotOwnerOrganizationName"
            :hide-delivery-condition="hideDeliveryCondition"
            :validated="createPosition" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            class="ma-1"
            color="primary"
            @click="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueOperationBtn"
            class="ma-1"
            :disabled="isLoading"
            color="primary"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import PositionInfoFix from './PositionInfoFix.vue'
  import PositionInfoDifferential from './PositionInfoDifferential.vue'
  import GeneralError from '../common/GeneralError.vue'
  import { mapState, mapActions } from 'vuex'
  import { PREMIUM_TYPES, DICTIONARY_TYPES } from '@/constants/business'
  import { LOT_POSITIONS_MANAGEMENT, DICTIONARIES } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      PositionInfoFix,
      PositionInfoDifferential
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lot: {
              lotId: null,
              premiumType: null,
              incotermId: null
            },
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        PREMIUM_TYPES,
        isLoading: false
      }
    },
    computed: {
      ...mapState(DICTIONARIES.NAMESPACE, {
        incoterms: state => state[DICTIONARY_TYPES.INCOTERMS] || []
      }),
      lotOwnerOrganizationName () {
        return this.dialogProp.lot?.organizer?.organizationName
      },
      hideDeliveryCondition () {
        return !!this.incoterms
        .find(i => i.incotermId === this.dialogProp.lot.incotermId)?.hasBasises
      }
    },
    created () {
      const vm = this
      if (!vm.dialogProp.lot.premiumType || !vm.dialogProp.lot.lotId) {
        vm.showErrorAction({
          message: vm.$t('Торговая процедура не определена.')
        })
      }
      vm.clearStore().then(() => {
        if (!vm.incoterms.length) {
          vm.getIncoterms()
        }
      })
    },
    methods: {
      ...mapActions(LOT_POSITIONS_MANAGEMENT.NAMESPACE, {
        createPositionAction: LOT_POSITIONS_MANAGEMENT.ACTIONS.CREATE_POSITION
      }),
      ...mapActions(DICTIONARIES.NAMESPACE, {
        getBusinessDictionaryItemsAction: DICTIONARIES.ACTIONS.GET_BUSINESS_DICTIONARY_ITEMS,
        clearDictionaryItemsAction: DICTIONARIES.ACTIONS.CLEAR_DICTIONARY_ITEMS
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearDictionaryItemsAction(DICTIONARY_TYPES.INCOTERMS)
          ])
      },
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.position.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      getIncoterms: async function () {
        try {
          this.isLoading = true
          await this.getBusinessDictionaryItemsAction({
            dictionaryType: DICTIONARY_TYPES.INCOTERMS
          })
        } catch (error) {
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      createPosition: async function (position) {
        const model = {
          premiumType: this.dialogProp.lot.premiumType,
          lotId: this.dialogProp.lot.lotId,
          lotType: this.dialogProp.lot.lotType,
          position
        }
        await Promise.all([
          this.createPositionAction(model)
        ])
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
